/**
 * The tool belt's words (ADR-142 decision 3b and its note of 2026-10-29, P2.26-T17), every one a draft for the author:
 * its label, its slots' and chip's names for a screen reader, the line a tool in hand and a tool put away show, and the
 * hints of the touch chip. `{tool}` is the tool's item name, `{key}` the key that cycles tools, `{slot}` a place on the
 * belt from 1.
 */
export const BELT = {
  title: "Tools",
  slot: "Tool {slot}",
  slotNamed: "Tool {slot}, {tool}",
  slotSelected: "Tool {slot}, {tool}, in hand",
  chip: "Tools",
  chipHolding: "Tools, {tool} in hand",
  chipEmpty: "Tools, none in hand",
  inHand: "{tool} in hand. {key} to put away.",
  putAway: "{tool} put away. {key} to take it out.",
  inHandTouch: "{tool} in hand. Tap Tool, then {tool}, to put it away.",
  putAwayTouch: "{tool} put away. Tap Tool, then {tool}, to take it out.",
  onlyTools: "Only tools go on the belt.",
  fanHint: "Tap a tool to take it out.\nTap it again to put it away.",
  dragHint: "Long press, then drag onto Tool.",
} as const;
